import * as React from 'react';
import { useRouteMatch } from 'react-router';
import { Switch } from 'react-router-dom';

import { PrivateRoute } from '~/components/Auth';
import { RehireEmployee } from '~/scenes/PortalModules/RehireEmployee';

export const RehireEmployeeRouter = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <PrivateRoute
        path={path}
        render={() => {
          return <RehireEmployee />;
        }}
      />
    </Switch>
  );
};
